import { Directive, DestroyRef, ElementRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AppConfigService } from 'app/services/local/app-config.service';

@Directive({
  selector: '[appLogo]',
  standalone: true,
})
export class AppLogoDirective implements OnInit {
  @Input('appLogo') variant: 'general' | 'sinTexto';

  private el = inject(ElementRef<HTMLImageElement>);
  private appConfigService = inject(AppConfigService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.appConfigService.config$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((config) => {
        const url = this.variant === 'general' ? config.logoGeneralUrl : config.logoSinTextoUrl;
        if (url) {
          this.el.nativeElement.src = url;
        }
      });
  }
}
